var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9996 9.25V10.05C12.9996 11.1701 12.9996 11.7302 12.7816 12.158C12.5899 12.5343 12.2839 12.8403 11.9076 13.032C11.4798 13.25 10.9198 13.25 9.79969 13.25H4.19989C3.07982 13.25 2.51979 13.25 2.09198 13.032C1.71567 12.8403 1.40972 12.5343 1.21798 12.158C1 11.7302 1 11.1701 1 10.05V9.25M10.333 5.91667L6.99979 9.25M6.99979 9.25L3.66657 5.91667M6.99979 9.25V1.25",
    stroke: "#212121",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.a8a50334f75e7b60cbce1fdad4c755af.svg";
export { ForwardRef as ReactComponent };